import { render, staticRenderFns } from "./compositionAddPage.vue?vue&type=template&id=b97b6dc6&scoped=true&"
import script from "./compositionAddPage.vue?vue&type=script&lang=js&"
export * from "./compositionAddPage.vue?vue&type=script&lang=js&"
import style0 from "./compositionAddPage.vue?vue&type=style&index=0&id=b97b6dc6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b97b6dc6",
  null
  
)

export default component.exports